module.exports = __webpack_public_path__ + "img/icon-time.616b3e71.svg";